import styled from 'styled-components';
import TextField from '@app/components/atoms/TextField';
import { Grid } from '@mui/material';
import { deviceSizes } from '@app/config/devices';
export var SubFooterContainer = styled.div.withConfig({
  displayName: "style__SubFooterContainer",
  componentId: "sc-sdwrgi-0"
})(["width:100%;background-color:", ";color:", ";padding:0 150px;.mainContainer{align-items:center;justify-content:space-between;}.locales{border-right:1px solid ", ";padding:0.5rem;}@media (max-width:", "){padding:0 50px;}@media (max-width:", "){padding:0 10px;.mainContainer{flex-direction:column-reverse;align-items:flex-start;}}@media (max-width:", "){.currency{justify-content:center;align-items:center;margin-bottom:10px;}.copyright{text-align:center;width:100%;margin-bottom:10px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryColor[700];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.secondaryColor[600];
}, deviceSizes.md, deviceSizes.sm, deviceSizes.sm);
export var StyledTextField = styled(TextField).withConfig({
  displayName: "style__StyledTextField",
  componentId: "sc-sdwrgi-1"
})(["&&{margin:0;span{color:white;}&:hover{border:none;}.MuiOutlinedInput-notchedOutline{border:none;}.MuiSelect-outlined.MuiSelect-outlined{padding:0;}}svg{fill:white;margin-left:5px;}"]);
export var CurrencyBox = styled(Grid).withConfig({
  displayName: "style__CurrencyBox",
  componentId: "sc-sdwrgi-2"
})(["padding:10px;border-left:1px solid ", ";border-right:1px solid ", ";@media (max-width:", "){border-left:none;border-right:none;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.secondaryColor[600];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.secondaryColor[600];
}, deviceSizes.sm);
export var LanguagesBox = styled(Grid).withConfig({
  displayName: "style__LanguagesBox",
  componentId: "sc-sdwrgi-3"
})(["padding:10px;border-right:1px solid ", ";@media (max-width:", "){border-right:none;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.secondaryColor[600];
}, deviceSizes.sm);